import { useCallback, useState } from 'react';
import { paymentsAPI } from '../../services/api';

export function usePayments({ dispatch, useAPI }) {
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);

  const fetchPaymentHistory = useCallback(async (bookingId) => {
    if (!bookingId) return [];
    setHistoryLoading(true);
    try {
      const response = await paymentsAPI.getHistory(bookingId);
      const history = response.success && Array.isArray(response.data) ? response.data : [];
      setPaymentHistory(history);
      return history;
    } catch (error) {
      console.error('Error fetching payment history:', error);
      setPaymentHistory([]);
      return [];
    } finally {
      setHistoryLoading(false);
    }
  }, []);

  const markPaymentComplete = useCallback(
    async (bookingId, paymentInfo) => {
      try {
        if (useAPI) {
          const response = await paymentsAPI.record({
            booking_id: bookingId,
            amount: paymentInfo.amountPaid,
            payment_date: paymentInfo.paymentDate,
            payment_mode: paymentInfo.paymentMode,
            paid_by: paymentInfo.paidBy,
            mobile: paymentInfo.mobile,
          });

          if (response.success && response.data) {
            dispatch({
              type: 'UPDATE_PAYMENT_STATUS',
              payload: {
                id: bookingId,
                amountPaid: paymentInfo.amountPaid,
                paymentDate: paymentInfo.paymentDate,
                paymentMode: paymentInfo.paymentMode,
                paidBy: paymentInfo.paidBy,
                mobile: paymentInfo.mobile,
                newAdvance: response.data.newAdvance,
                newBalance: response.data.newBalance,
                isFullyPaid: response.data.isFullyPaid,
              },
            });
            return { success: true, data: response.data };
          }
          throw new Error(response.message || 'Failed to record payment');
        }

        dispatch({
          type: 'UPDATE_PAYMENT_STATUS',
          payload: {
            id: bookingId,
            amountPaid: paymentInfo.amountPaid,
            paymentDate: paymentInfo.paymentDate,
            paymentMode: paymentInfo.paymentMode,
            paidBy: paymentInfo.paidBy,
            mobile: paymentInfo.mobile,
            newAdvance: paymentInfo.newAdvance,
            newBalance: paymentInfo.newBalance,
            isFullyPaid: paymentInfo.isFullyPaid,
          },
        });
        return { success: true };
      } catch (error) {
        console.error('Error recording payment:', error);
        dispatch({
          type: 'UPDATE_PAYMENT_STATUS',
          payload: {
            id: bookingId,
            amountPaid: paymentInfo.amountPaid,
            paymentDate: paymentInfo.paymentDate,
            paymentMode: paymentInfo.paymentMode,
            paidBy: paymentInfo.paidBy,
            mobile: paymentInfo.mobile,
            newAdvance: paymentInfo.newAdvance,
            newBalance: paymentInfo.newBalance,
            isFullyPaid: paymentInfo.isFullyPaid,
          },
        });
        return { success: false, error: error.message };
      }
    },
    [dispatch, useAPI]
  );

  return { markPaymentComplete, fetchPaymentHistory, paymentHistory, historyLoading };
}
